<style lang="scss" scoped>
  .opera-btn-group .advanced-query-form > .el-row {
    display: block;
    .oms-form-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div class="opera-btn-group " :class="{up:!showSearch}">
    <form onsubmit="return false">
      <div class="opera-icon ">
        <el-row>
          <el-col :span="8">
            <div v-show="!showSearch">
              <el-col :span="6" class="text-right" style="padding-right: 5px">
                货主订单号
              </el-col>
              <el-col :span="16">
                <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4" v-show="!showSearch">
            <div>
              <oms-form-row label="" :span="6">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </div>
          </el-col>
          <el-col :span="!showSearch ? 10 : 24 " class="opera-btn">
            <span class="pull-right" style="margin-left: 10px" v-if="bizType === '2-0'">
              <des-btn custom icon="plus" @click="batchImportExcel" :perm="perm.add">批量导入</des-btn>
            </span>
            <span class="pull-right" style="margin-left: 10px" v-if="bizType === '2-0' && status === '0'">
              <des-btn custom icon="review" @click="batchReview" :perm="perm.batchConfirm">批量审单</des-btn>
            </span>
            <span class="pull-right" style="margin-left: 10px">
              <des-btn custom icon="plus" @click="add" :perm="perm.add">添加</des-btn>
            </span>
            <span class="pull-right switching-icon" @click="showSearch = !showSearch">
            <i class="el-icon-arrow-up"></i>
            <span v-show="showSearch">高级搜索</span>
            <span v-show="!showSearch">高级搜索</span>
           </span>
            <goods-switch class="pull-right"></goods-switch>
          </el-col>
        </el-row>
      </div>
    </form>
    <el-form v-show="showSearch" class="advanced-query-form clearfix"
             onsubmit="return false">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="6" label="货主订单号">
            <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="货品主档">
            <goods-select :remote-method="queryDhsGoods" placeholder="请输入名称搜索货品主档"
                          v-model="searchCondition.goodsId" :list="dhsGoodsList"></goods-select>
          </oms-form-row>
        </el-col>
<!--        <el-col :span="8" v-show="!isNeed">-->
<!--          <oms-form-row label="业务类型" :span="6">-->
<!--            <el-select type="text" v-model="searchCondition.bizType" placeholder="请选择业务类型" clearable>-->
<!--              <el-option :value="item.key" :key="item.key" :label="item.label"-->
<!--                         v-for="item in bizTypes"></el-option>-->
<!--            </el-select>-->
<!--          </oms-form-row>-->
<!--        </el-col>-->
        <el-col :span="8" v-show="!isNeed">
          <oms-form-row :label="$formatOrderType(type)" :span="6">
            <org-select :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索${$formatOrderType(type)}`" :remote-method="queryDownList"
                        v-model="searchCondition.downstreamOrgId" :list="downOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :label="`${$formatOrderType(type)}订单号`" :span="7">
            <oms-input type="text" v-model.trim="searchCondition.orderThirdNo" placeholder="请输入来源订单号"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="下单时间" :span="5">
            <el-col :span="24">
              <el-date-picker
                v-model="createdTimes"
                type="datetimerange"
                placeholder="请选择">
              </el-date-picker>
            </el-col>
          </oms-form-row>
        </el-col>
        <el-col :span="8" v-show="!isNeed">
          <oms-form-row label="订单状态" :span="6">
            <el-select type="text" v-model="searchCondition.status" clearable placeholder="请选择订单状态">
              <el-option :value="item.status" :key="item.status" :label="item.title"
                         v-for="item in orgType"></el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="" :span="6">
            <el-button class="ml-15" type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
            <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    props: {
      bizTypes: Array,
      orgType: Object,
      activeStatus: [String, Boolean],
      bizType: String,
      status: String
    },
    mixins: [MethodsMix],
    data() {
      return {
        showSearch: false,
        createdTimes: '',
        searchCondition: {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: ''
        },
      };
    },
    computed: {
      perm() {
        return this.$route.meta.pagerPerm;
      },
      type() {
        return this.$route.meta.type;
      },
      isNeed() {
        return this.$route.meta.isNeed || this.$route.meta.isPurchaseReturn;
      },
      isNeedOrder() {
        return this.$route.meta.isNeed;
      },
      isPurchaseReturnOrder() {
        return this.$route.meta.isPurchaseReturn;
      }
    },
    methods: {
      searchInOrder: function () {// 搜索
        this.searchCondition.createStartTime = this.$formatAryTime(this.createdTimes, 0, 'YYYY-MM-DD HH:mm:ss');
        this.searchCondition.createEndTime = this.$formatAryTime(this.createdTimes, 1, 'YYYY-MM-DD HH:mm:ss');
        this.$emit('editShowType', false);
        this.$emit('editFilters', this.searchCondition);
        // 判断是否有查询参数，没有，显示状态
        let isInputParams = Object.keys(this.searchCondition).some(k => this.searchCondition[k]);
        if (!isInputParams) {
          //重新设置订单状态
          this.$emit('editShowType', true);
          this.$emit('editFilters', {status: this.orgType[this.activeStatus].status});
          return;
        }
        this.$emit('refresh');
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: ''
        };
        this.createdTimes = '';
        this.$emit('editShowType', true);
        Object.assign(this.searchCondition, temp);
        temp.status = this.orgType[this.activeStatus].status;
        this.$emit('editFilters', temp);
      },
      resetForm() {
        this.searchCondition = {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: ''
        };
        this.createdTimes = '';
      },
      add () {
        this.$emit('add');
      },
      batchReview() {
        this.$emit('batchReview');
      },
      batchImportExcel() {
        this.$emit('batchImportExcel');
      },
    }
  };
</script>
